// extracted by mini-css-extract-plugin
module.exports = {"AllocationTimes":"AllocationTimes_AllocationTimes_2dD-G","m2":"AllocationTimes_m2_IMqiD"};